export const ActionTypes = {
  FETCH_FACTORY_EFFICIENCY_GRID: 'services/dashboards/factoryEfficiency/fetch_factory_efficiency_grid',
  FETCH_FACTORY_AUTOMATION_EQUIPMENTS: 'services/dashboards/factoryEfficiency/fetch_factory_automation_equipments',
  FETCH_AUTOMATION_EQUIPMENT_CONFIGURATION:
    'services/dashboards/factoryEfficiency/fetch_automation_equipment_configuration',
  SET_FACTORY_AUTOMATION_EQUIPMENTS: 'services/dashboards/factoryEfficiency/set_factory_automation_equipments',
  SET_FACTORY_EFFICIENCY_GRID: 'services/dashboards/factoryEfficiency/set__factory_efficiency_grid',
  SET_FACTORY_EFFICIENCY_PARAMS: 'services/dashboards/factoryEfficiency/set_factory_efficiency_param',
  SET_LOADER_STATUS: 'services/dashboards/factoryEfficiency/set_loader_status',
  EDIT_TOOL_CAVITY: 'services/dashboards/factoryEfficiency/edit_tool_cavity',
  FETCH_TOOL_CAVITY_TABLE: 'services/dashboards/factoryEfficiency/fetch_tool_cavity_table',
  SET_TOOL_CAVITY_TABLE: 'services/dashboards/factoryEfficiency/set_tool_cavity_table',
  SET_MOVING_AUTOMATION_LOADER_STATUS: 'services/dashboards/factoryEfficiency/set_moving_automation_loader_status',
  SET_AUTOMATION_EQUIPMENT_CONFIGURATION:
    'services/dashboards/factoryEfficiency/set_automation_equipment_configuration',
  ATTACH_AUTOMATION_EQUIPMENT_TO_LINE: 'services/dashboards/factoryEfficiency/attach_automation_equipment_to_line',
  DETACH_AUTOMATION_EQUIPMENT_FROM_LINE: 'services/dashboards/factoryEfficiency/detach_automation_equipment_from_line',
  AUTOMATION_RECONCILIATION_AND_DETACH_EQUIPMENT_FROM_LINE:
    'services/dashboards/factoryEfficiency/automation_reconciliation_and_detach_equipment_from_line',
};

const fetchFactoryEfficiencyGrid = ({ params }) => ({
  params,
  type: ActionTypes.FETCH_FACTORY_EFFICIENCY_GRID,
});
const fetchFactoryAutomationEquipments = ({ factoryId }) => ({
  factoryId,
  type: ActionTypes.FETCH_FACTORY_AUTOMATION_EQUIPMENTS,
});
const editToolCavity = ({ toolCavity }) => ({
  toolCavity,
  type: ActionTypes.EDIT_TOOL_CAVITY,
});
const fetchToolCavityTable = () => ({
  type: ActionTypes.FETCH_TOOL_CAVITY_TABLE,
});

const setToolCavityTable = ({ toolCavityTable }) => ({
  toolCavityTable,
  type: ActionTypes.SET_TOOL_CAVITY_TABLE,
});

const fetchAutomationEquipmentConfiguration = ({ lineId, jobId }) => ({
  lineId,
  jobId,
  type: ActionTypes.FETCH_AUTOMATION_EQUIPMENT_CONFIGURATION,
});

const setFactoryEfficiencyGrid = ({ factoryEfficiencyGrid }) => ({
  factoryEfficiencyGrid,
  type: ActionTypes.SET_FACTORY_EFFICIENCY_GRID,
});
const setLoader = ({ showLoader }) => ({
  showLoader,
  type: ActionTypes.SET_LOADER_STATUS,
});
const setFactoryEfficiencyParams = ({ params }) => ({
  params,
  type: ActionTypes.SET_FACTORY_EFFICIENCY_PARAMS,
});

const setMovingAutomationLoader = ({ movingAutomationLoader }) => ({
  movingAutomationLoader,
  type: ActionTypes.SET_MOVING_AUTOMATION_LOADER_STATUS,
});

const setFactoryAutomationEquipments = ({ automationEquipments }) => ({
  automationEquipments,
  type: ActionTypes.SET_FACTORY_AUTOMATION_EQUIPMENTS,
});
const setAutomationEquipmentConfiguration = ({ equipmentConfiguration }) => ({
  equipmentConfiguration,
  type: ActionTypes.SET_AUTOMATION_EQUIPMENT_CONFIGURATION,
});
const attachAutomationToLine = ({ request, callback }) => ({
  request,
  callback,
  type: ActionTypes.ATTACH_AUTOMATION_EQUIPMENT_TO_LINE,
});
const detachAutomationFromLine = ({ request, callback }) => ({
  request,
  callback,
  type: ActionTypes.DETACH_AUTOMATION_EQUIPMENT_FROM_LINE,
});
const automationReconciliationAndDetachEquipmentFromLine = ({ request, callback }) => ({
  request,
  callback,
  type: ActionTypes.AUTOMATION_RECONCILIATION_AND_DETACH_EQUIPMENT_FROM_LINE,
});

export default {
  fetchFactoryEfficiencyGrid,
  fetchFactoryAutomationEquipments,
  fetchAutomationEquipmentConfiguration,
  setFactoryEfficiencyParams,
  setFactoryEfficiencyGrid,
  setLoader,
  setMovingAutomationLoader,
  setFactoryAutomationEquipments,
  setAutomationEquipmentConfiguration,
  attachAutomationToLine,
  detachAutomationFromLine,
  editToolCavity,
  fetchToolCavityTable,
  setToolCavityTable,
  automationReconciliationAndDetachEquipmentFromLine,
};
